<div class="md-input-container">
<mat-form-field class="inputassign" appearance="legacy" flex color="accent" style="padding: 0">
    <mat-label>Charge Type</mat-label>
    <mat-select
                 [(ngModel)]="value" [disabled]="disabled"
                (openedChange)="onOpen($event)"
                (selectionChange)="onValChange($event)"
                name="charge_id"
                [compareWith]="objectComparison"
                #charge_id="ngModel"
                [required]="required">
        <mat-option *ngIf="items === null || !items?.length" class="minh88" disabled>
            <div class="select-placeholder-container">
                <mat-spinner class="spinner" diameter="20"></mat-spinner>
            </div>
        </mat-option>
        <mat-option *ngFor="let item of items" [value]="item">{{item.Title}}</mat-option>
    </mat-select>
    <mat-error *ngIf="!charge_id.valid && charge_id.touched && required">Required</mat-error>
</mat-form-field>
<mat-icon
        *ngIf="helptext!=''"
        [matTooltip]="helptext"
        matTooltipPosition="above" class="ng-scope md-iwgNavbar-theme material-icons">help
</mat-icon>
</div>






